import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Cloud } from "lucide-react";

interface FileManagerProps {
  onBack: () => void;
}

const FileManager = ({ onBack }: FileManagerProps) => {
  const files = [
    { name: "Document1.pdf", modified: "2024-02-20", size: "2.4 MB" },
    { name: "Image1.jpg", modified: "2024-02-19", size: "1.1 MB" },
  ];

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <Button variant="outline" onClick={onBack}>
          Back to Options
        </Button>
        <Button variant="outline" className="gap-2">
          <Cloud className="w-4 h-4" />
          Connect to OneDrive
        </Button>
      </div>
      <Card>
        <CardHeader>
          <CardTitle>Your Files</CardTitle>
        </CardHeader>
        <CardContent>
          <ScrollArea className="h-[400px] w-full rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Name</TableHead>
                  <TableHead>Modified</TableHead>
                  <TableHead>Size</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {files.map((file) => (
                  <TableRow key={file.name}>
                    <TableCell>{file.name}</TableCell>
                    <TableCell>{file.modified}</TableCell>
                    <TableCell>{file.size}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </ScrollArea>
        </CardContent>
      </Card>
    </div>
  );
};

export default FileManager;